import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var PayoutCalculationIA = function PayoutCalculationIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "GoibG8",
    defaultMessage: "Payouts for brands on Faire are calculated using the following formula: Payout amount = (order subtotal) + (shipping reimbursement) - (commission) - (payment processing fee)"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "UVFpLi",
    defaultMessage: "<BoldFormatting>Order subtotal</BoldFormatting>: Cumulative wholesale cost of the items in the order, minus any brand-funded promotions.",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "EZKlAY",
    defaultMessage: "<BoldFormatting>Shipping reimbursement</BoldFormatting>: The cost of shipping (only applies when the order is fulfilled on your own, not using Ship with Faire)",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "AWOZxu",
    defaultMessage: "<BoldFormatting>Commission</BoldFormatting>: Order subtotal x commission rate for that order",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "zNePjD",
    defaultMessage: "<BoldFormatting>Payment processing fee</BoldFormatting>: Item subtotal x payment processing fee",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "H3tdjk",
    defaultMessage: "You can see a full calculation of your payout under your <BoldFormatting>Orders</BoldFormatting> tab by clicking on the order\u2019s detail page. Scroll to the <BoldFormatting>You got paid!</BoldFormatting> section and select <BoldFormatting>View Payout Summary</BoldFormatting>. There you will find a detailed breakdown of the payout.",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};